import * as React from "react";
import { forwardRef } from "react";
const SvgIcChevronRight24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 11.9999L7.16016 5.28024L8.47084 3.9696L16.0009 11.4999V12.5606L8.47084 20.0909L7.16016 18.7803L14 11.9999Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcChevronRight24);
export { ForwardRef as ReactComponent };
